import type { IssueBoardDTO, TaskIssueDTO } from "../../common/api/types.js";

/** Ordnet jedes Issue genau der Spalte zu, deren Wert im Gruppierungsfeld steht. */
export function groupIssues(board: IssueBoardDTO, issues: readonly TaskIssueDTO[]): Record<string, TaskIssueDTO[]> {
  const grouped = Object.fromEntries(board.columns.map((column) => [column.id, [] as TaskIssueDTO[]]));
  for (const issue of issues) {
    const column = board.columns.find((entry) => entry.value === issue.fields[board.groupByFieldId]);
    if (column) grouped[column.id]?.push(issue);
  }
  return grouped;
}
